import { Injectable } from '@angular/core';
import { RestApiService } from './rest-api.service';
import { RestApiEndpoints } from '../enums/rest-api-endpoints';
import { CredentialsService } from './credentials.service';

declare function createPDF(orientation: string, measurement: string, size: string): any;
declare function imageFieldToBaseObject(fieldID: string, wantedHeight: number): any;

@Injectable({
    providedIn: 'root'
})
export class FileService {

    pdfDocument: any = null;
    pdfDocumentName: any = null;
    private fileImportQueue?: any[];

    constructor(
        private restApiService: RestApiService,
        private credentialsService: CredentialsService) { }

    convertFileArrayToBaseArray(fileArray: any, completionHandler: any) {
        if (!fileArray || !completionHandler) {
            completionHandler(null);
            return;
        }

        var tmpFileCount: number = fileArray.length;
        var tmpFileCache: any[] = [];
        for (var i = 0, file; file = fileArray[i]; i++) {
            var reader = new FileReader();

            reader.onloadend = (function (file) {
                return function (readResult) {
                    var baseFile = {
                        name: file.name,
                        payload: readResult.target?.result
                    };

                    tmpFileCache.push(baseFile);
                    tmpFileCount--;

                    if (tmpFileCount == 0) {
                        completionHandler(tmpFileCache);
                    }
                };
            })(fileArray[i]);

            reader.onerror = function () {
                tmpFileCount--;
            };

            reader.readAsDataURL(file);
        }
    }

    createCasketLabel(pdfContentObject: any) {
        this.pdfDocumentName = 'Sargetikett';

        var qrLogo = null;
        if (pdfContentObject.hasOwnProperty('qrLogo')) {
            qrLogo = pdfContentObject.qrLogo;
        }
        var userLogo = null;
        if (pdfContentObject.hasOwnProperty('userLogo')) {
            userLogo = pdfContentObject.userLogo;
        }
        var fullName = '';
        if (pdfContentObject.hasOwnProperty('fullName')) {
            fullName = pdfContentObject.fullName;
            this.pdfDocumentName += ' ' + fullName;
        }
        var gender = '';
        if (pdfContentObject.hasOwnProperty('gender')) {
            gender = pdfContentObject.gender;
        }
        var birthDate = '';
        if (pdfContentObject.hasOwnProperty('birthDate')) {
            birthDate = pdfContentObject.birthDate;
        }
        var deathDate = '';
        if (pdfContentObject.hasOwnProperty('deathDate')) {
            deathDate = pdfContentObject.deathDate;
        }
        var pickupDate = '';
        if (pdfContentObject.hasOwnProperty('pickupDate')) {
            pickupDate = pdfContentObject.pickupDate;
        }
        var pickupTime = '';
        if (pdfContentObject.hasOwnProperty('pickupTime')) {
            pickupTime = pdfContentObject.pickupTime;
        }
        var adoptionType = '';
        if (pdfContentObject.hasOwnProperty('adoptionType')) {
            adoptionType = pdfContentObject.adoptionType;
        }
        var adoptionDate = '';
        if (pdfContentObject.hasOwnProperty('adoptionDate')) {
            adoptionDate = pdfContentObject.adoptionDate;
        }
        var adoptionTime = '';
        if (pdfContentObject.hasOwnProperty('adoptionTime')) {
            adoptionTime = pdfContentObject.adoptionTime;
        }
        var burialType = '';
        if (pdfContentObject.hasOwnProperty('burialType')) {
            burialType = pdfContentObject.burialType;
        }
        var burialSuiteDate = '';
        if (pdfContentObject.hasOwnProperty('burialSuiteDate')) {
            burialSuiteDate = pdfContentObject.burialSuiteDate;
        }
        var burialSuiteTime = '';
        if (pdfContentObject.hasOwnProperty('burialSuiteTime')) {
            burialSuiteTime = pdfContentObject.burialSuiteTime;
        }
        var burialDate = '';
        if (pdfContentObject.hasOwnProperty('burialDate')) {
            burialDate = pdfContentObject.burialDate;
        }
        var burialTime = '';
        if (pdfContentObject.hasOwnProperty('burialTime')) {
            burialTime = pdfContentObject.burialTime;
        }
        var returnType = '';
        if (pdfContentObject.hasOwnProperty('returnType')) {
            returnType = pdfContentObject.returnType;
        }
        var returnDate = '';
        if (pdfContentObject.hasOwnProperty('returnDate')) {
            returnDate = pdfContentObject.returnDate;
        }
        var returnTime = '';
        if (pdfContentObject.hasOwnProperty('returnTime')) {
            returnTime = pdfContentObject.returnTime;
        }
        var bestatterString = '';
        if (pdfContentObject.hasOwnProperty('bestatterString')) {
            bestatterString = pdfContentObject.bestatterString;
        }

        var stuffArray = [];
        if (pdfContentObject.hasOwnProperty('stuffArray')) {
            stuffArray = pdfContentObject.stuffArray;
        }

        this.pdfDocument = createPDF('landscape', 'pt', 'a5');
        var pageWidth = 595;
        var pageHeight = 419;
        var topStart = 48;
        var leftStart = 18;
        var leftInnerStart = 72;
        var rightStart = 18;
        var bottomStart = 18;

        var rectStartY = 0;
        var nextY = topStart;

        this.pdfDocument.setFont('arial', 'normal');
        this.pdfDocument.setFontSize(12);
        this.pdfDocument.text(leftInnerStart, nextY, bestatterString);
        nextY += 28;

        this.pdfDocument.setFont('arial', 'bold');
        this.pdfDocument.setFontSize(20);
        this.pdfDocument.text(leftInnerStart, nextY, fullName);
        nextY += 25;

        this.pdfDocument.setFont('arial', 'normal');
        this.pdfDocument.setFontSize(12);
        this.pdfDocument.text(leftInnerStart, nextY, 'Geburtsdatum: ' + birthDate);
        this.pdfDocument.text((leftInnerStart + 193), nextY, 'Sterbedatum: ' + deathDate);
        rectStartY = nextY + 5;
        nextY += 23;

        if (qrLogo) {
            this.pdfDocument.addImage(qrLogo, 'PNG', leftStart, (topStart - 10), 40, 40);
        }

        this.pdfDocument.setFont('arial', 'bold');
        this.pdfDocument.text((leftInnerStart + 8), nextY, 'Termine');
        this.pdfDocument.text((leftInnerStart + 118), nextY, 'Datum');
        this.pdfDocument.text((leftInnerStart + 193), nextY, 'Uhrzeit');
        this.pdfDocument.text((leftInnerStart + 248), nextY, 'Infos');
        nextY += 30;

        var stuffLineY = nextY;
        for (var stuffArrayIndex in stuffArray) {
            this.pdfDocument.text((leftInnerStart + 248), stuffLineY, stuffArray[stuffArrayIndex]);
            stuffLineY += 15;
        }

        if (pickupDate.length > 0) {
            this.pdfDocument.setFont('arial', 'normal');
            this.pdfDocument.text((leftInnerStart + 8), nextY, 'Abholung');
            this.pdfDocument.text((leftInnerStart + 118), nextY, pickupDate);
            this.pdfDocument.text((leftInnerStart + 193), nextY, pickupTime);
            nextY += 30;
        }

        if (adoptionType.length > 0) {
            this.pdfDocument.text((leftInnerStart + 8), nextY, adoptionType);
            this.pdfDocument.text((leftInnerStart + 118), nextY, adoptionDate);
            this.pdfDocument.text((leftInnerStart + 193), nextY, adoptionTime);
            var adoptionTypeTypeLines = adoptionType.split('\n').length;
            nextY += (adoptionTypeTypeLines * 20);
        }

        if (burialDate.length > 0) {
            this.pdfDocument.text((leftInnerStart + 8), nextY, 'Früheste\nEinäscherung');
            this.pdfDocument.text((leftInnerStart + 118), nextY, burialDate);
            this.pdfDocument.text((leftInnerStart + 193), nextY, burialTime);
            nextY += 50;
        }

        ///////////////////
        if (burialType.length > 0) {
            this.pdfDocument.text((leftInnerStart + 8), nextY, burialType);
            this.pdfDocument.text((leftInnerStart + 118), nextY, burialSuiteDate);
            this.pdfDocument.text((leftInnerStart + 193), nextY, burialSuiteTime);
            var burialTypeTypeLines = burialType.split('\n').length;
            nextY += (burialTypeTypeLines * 20);
        }
        ///////////////////*/

        if (returnType.length > 0) {
            this.pdfDocument.text((leftInnerStart + 8), nextY, returnType);
            this.pdfDocument.text((leftInnerStart + 118), nextY, returnDate);
            this.pdfDocument.text((leftInnerStart + 193), nextY, returnTime);
        }

        this.pdfDocument.rect(leftInnerStart, rectStartY, (pageWidth - leftInnerStart - rightStart), (pageHeight - (topStart * 3)), 'fill');
        this.pdfDocument.rect(leftInnerStart, rectStartY, 110, (pageHeight - (topStart * 3)), 'fill');
        this.pdfDocument.rect((leftInnerStart + 110), rectStartY, 77, (pageHeight - (topStart * 3)), 'fill');
        this.pdfDocument.rect((leftInnerStart + 187), rectStartY, 53, (pageHeight - (topStart * 3)), 'fill');
        this.pdfDocument.rect((leftInnerStart + 240), rectStartY, (pageWidth - leftInnerStart - rightStart - 240), (pageHeight - (topStart * 3)), 'fill');
        nextY = (rectStartY + ((pageHeight - (topStart * 3)) + 11));

        this.pdfDocument.rect(leftInnerStart, rectStartY, (pageWidth - leftInnerStart - rightStart), 25, 'fill');

        this.pdfDocument.setFontSize(9);
        this.pdfDocument.text(leftInnerStart, nextY, '© by weinand.it GmbH');

        return this.pdfDocument.output('dataurlstring');
    }

    createPDFOfType(pdfType: string, pdfContentObject: any) {
        if (!pdfType) { return null; }
        switch (pdfType) {
            case 'casketLabel':
                if (!pdfContentObject) { return null; }
                return this.createCasketLabel(pdfContentObject);
                break;
        }
        return null;
    }

    convertImagesToPDF(imageBaseString: any, completionHandler: any) {
        if (imageBaseString.startsWith('data:application/pdf')) {
            // PDF-Dateien direkt weiterreichen ohne Bildkonvertierung
            completionHandler(imageBaseString);
        } else {
            var globalIMG: any = document.getElementById('globalImg');
    
            if (!globalIMG) { return; }
    
            globalIMG.onload = function () {
                if (!globalIMG) { return; }
                globalIMG.onload = null;
                const baseObject = imageFieldToBaseObject('globalImg', 400);
                completionHandler(baseObject.payload);
            };
    
            globalIMG.src = imageBaseString;
        }
    }

    downloadCurrentPDFDocument() {
        if (this.pdfDocument) {
            this.pdfDocument.save(this.pdfDocumentName + '.pdf');
        }
    }

    createBlobUrlFromBaseString(baseString: string, mimeType: string): string {
        const base64 = baseString.replace('data:' + mimeType + ';base64,', '');
        const blob = this.base64toBlob(base64, mimeType);
        return URL.createObjectURL(blob);
    }

    private base64toBlob(base64Data: string, mimeType: string): any {
        mimeType = mimeType || '';
        var sliceSize = 1024;
        var byteCharacters = atob(base64Data);
        var bytesLength = byteCharacters.length;
        var slicesCount = Math.ceil(bytesLength / sliceSize);
        var byteArrays = new Array(slicesCount);

        for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            var begin = sliceIndex * sliceSize;
            var end = Math.min(begin + sliceSize, bytesLength);

            var bytes = new Array(end - begin);
            for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }

            byteArrays[sliceIndex] = new Uint8Array(bytes);
        }

        return new Blob(byteArrays, { type: mimeType });
    }

    importFiles(files: File[], completionHandler?: () => void) {
        this.convertFileArrayToBaseArray(files, (baseArray: any[]) => {
            this.fileImportQueue = baseArray;
            this.importNextPdfFile(completionHandler);
        });
    }

    private importNextPdfFile(completionHandler?: () => void) {
        if (!this.fileImportQueue || this.fileImportQueue?.length <= 0) { return; }

        let nextPdfFile = this.fileImportQueue?.pop();

        if (!nextPdfFile) { return; }

        var postBody = {
            persistent: 1,
            payload: nextPdfFile.payload
        };

        this.restApiService.sendAsyncRequestToEndpoint(RestApiEndpoints.import, postBody, (success, response) => {
            if (!success || !response || !response.success) {
                this.importNextPdfFile(completionHandler);
                return;
            }

            if (!this.fileImportQueue || this.fileImportQueue?.length <= 0) {
                if (response.success && response.payload) {
                    this.credentialsService.importContractID = response.payload;
                }

                if (completionHandler) {
                    completionHandler();
                }
            } else {
                this.importNextPdfFile(completionHandler);
            }
        });
    }

}